import { createSelector } from 'reselect';

const selectNewReport = (state: any) => state.newReport;
// ========== ATTENDANCE REPORT SELECTOR ==========
export const selectNewReportResponse = createSelector(
	[selectNewReport],
	(newReport) => newReport.attendanceReport,
);
// ========== LEAVE REPORT SELECTOR ==========
export const selectLeaveReportResponse = createSelector(
	[selectNewReport],
	(newReport) => newReport.leaveReport,
);
// ========== SECTION WISE ATTENDANCE REPORT SELECTOR ==========
export const selectSectionWiseAttendanceReportResponse = createSelector(
	[selectNewReport],
	(newReport) => newReport.sectionWiseAttendanceReport,
);

// ========== MANAGEMENT LEAVE REPORT SELECTOR ==========
export const selectManagementLeaveReportResponse = createSelector(
    [selectNewReport],
    (newReport) => newReport.managementLeaveReport,
);

// ========== DESIGNATION WISE LEAVE REPORT SELECTOR ==========
export const selectDesignationWiseLeaveReportResponse = createSelector(
    [selectNewReport],
    (newReport) => newReport.designationWiseLeaveReport,
);

// ========== EMPLOYEE LEAVE REPORT SELECTOR ==========
export const selectEmployeeLeaveReportResponse = createSelector(
    [selectNewReport],
    (newReport) => newReport.employeeLeaveReport,
);

// ========== MONTHLY CHECKOUT REPORT SELECTORS ==========
export const selectMonthlyCheckoutReportResponse = createSelector(
    [selectNewReport],
    (newReport) => newReport.monthlyCheckoutReport,
);

export const selectMonthlyCheckoutDetailsReportResponse = createSelector(
    [selectNewReport],
    (newReport) => newReport.monthlyCheckoutDetailsReport,
);

// ========== COMP OFF REPORT SELECTOR ==========
export const selectCompOffReportResponse = createSelector(
    [selectNewReport],
    (newReport) => newReport.compOffReport,
);

// ========== REFRESHMENT REPORT SELECTOR ==========
export const selectRefreshmentReportResponse = createSelector(
    [selectNewReport],
    (newReport) => newReport.refreshmentReport,
);

// ========== ON DUTY REPORT SELECTOR ==========
export const selectOnDutyReportResponse = createSelector(
	[selectNewReport],
	(newReport) => newReport.onDutyReport,
);

// ========== GET ALL EMPLOYEES CHECK-IN/CHECK-OUT SELECTOR ==========
export const selectAllEmployeesCheckInOutResponse = createSelector(
	[selectNewReport],
	(newReport) => newReport.allEmployeesCheckInOut,
);

// ========== MONTHLY ATTENDANCE SUMMARY REPORT SELECTOR ==========
export const selectMonthlyAttendanceSummaryReportResponse = createSelector(
    [selectNewReport],
    (newReport) => newReport.monthlyAttendanceSummaryReport,
);

// ========== CHECK-IN LOCKED SELECTORS START ==========
export const selectCheckInLockedResponse: any = createSelector(
	[selectNewReport],
	(newReport) => newReport.checkInLockedResponse,
);

export const selectCheckInLockedHistoryResponse: any = createSelector(
	[selectNewReport],
	(newReport) => newReport.checkInLockedHistoryResponse,
);

export const selectCheckInLockedExcuseResponse: any = createSelector(
	[selectNewReport],
	(newReport) => newReport.checkInLockedExcuseResponse,
);

export const selectCheckInUnLockedHistoryResponse: any = createSelector(
	[selectNewReport],
	(newReport) => newReport.checkInUnLockedHistoryResponse,
);
// ========== CHECK-IN LOCKED SELECTORS END ==========

// ========== FESTIVAL ADVANCE REPORT SELECTOR ==========
export const selectFestivalAdvanceReportResponse = createSelector(
	[selectNewReport],
	(newReport) => newReport.festivalAdvanceReport,
);

export const selectAllFestivalNamesResponse = createSelector(
	[selectNewReport],
	(newReport) => newReport.allFestivalNames,
);

export const selectUpdateFestivalAdvanceStatusResponse = createSelector(
	[selectNewReport],
	(newReport) => newReport.updateFestivalAdvanceStatus,
);
// ========== FESTIVAL ADVANCE REPORT SELECTOR END ==========

// ========== MEDICAL ALLOWANCE REPORT SELECTOR ==========
export const selectMedicalAllowanceReportResponse = createSelector(
	[selectNewReport],
	(newReport) => newReport.medicalAllowanceReport,
);

export const selectUpdateMedicalAllowanceStatusResponse = createSelector(
	[selectNewReport],
	(newReport) => newReport.updateMedicalAllowanceStatus,
);
// ========== MEDICAL ALLOWANCE REPORT SELECTOR END ==========